<script>
import messages from '@/mixins/messages'
import TermsOfServiceLink from './TermsOfServiceLink.vue'
import PaymentMethod from '../components/PaymentMethod.vue'
import { UserVoucherResource } from '@/resources/voucher'

export default {
    name: 'VoucherPitch',
    mixins: [messages],
    components: {
        TermsOfServiceLink,
        PaymentMethod
    },
    computed: {
        amountCents() {
            let userValue = parseInt(this.amountDollars)

            if (!userValue) {
                return 1e4
            }

            return userValue * 100
        },
    },
    watch: {
        userResource() {
            this.emailToFromName = this.userResource.fullName()
        }
    },
    data() {
        return {
            loading: true,
            amountDollars: 100,
            emailTo: false,
            emailToEmail: '',
            emailToFromName: '',
            emailToComments: '',
            userCardDetails: {},
            userResource: null,
            voucherResource: null,
            showSuccess: false
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.loading = true
                const extraData = !this.emailTo ? undefined : {
                    emailTo: this.emailToEmail,
                    emailFromName: this.emailToFromName,
                    emailComments: this.emailToComments
                }

                this.voucherResource = await UserVoucherResource.purchaseGiftCard(this.amountCents, extraData)
                this.showSuccess = true
                this.$emit('success', this.voucherResource)
            } catch(e) {
                throw this.axiosExtract(e)
            } finally {
                this.loading = false
            }
        },
        async onCardAdded() {
            this.userCardDetails = await this.userResource.getCard()
        },
        onSuccess() {
            this.$emit('done')
        },
        onClose() {
            this.$emit('close')
        }
    },
    async mounted() {
        this.userResource = await this.$store.dispatch('getUserResource')
        this.userCardDetails = await this.userResource.getCard()
        this.loading = false
    }
}
</script>

<template>
    <div class="voucher-pitch">
        <b-row v-if="!loading && !showSuccess">
            <b-col>
                <b-form @submit.prevent="onSubmit">
                    <b-form-group label="Valor del Vale de Regalo" label-cols-md="6">
                        <b-input-group :prepend="currencySymbol()" append=".00">
                            <b-form-input type="number" v-model="amountDollars"></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <hr />

                    <p><strong>Se te enviará un código de vale por correo electrónico.</strong> Este código de vale se puede usar para reservar reservas para cualquier tipo de simulador en cualquier fecha/hora.</p>
                    
                    <p><b-form-checkbox v-model="emailTo">Enviar este código de vale por correo electrónico a alguien especial</b-form-checkbox></p>

                    <div v-if="emailTo">
                        <b-form-group label="Dirección de Correo Electrónico del Destinatario">
                            <b-form-input type="email" v-model="emailToEmail" placeholder="Dirección de Correo Electrónico"  :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Tu Nombre">
                            <b-form-input v-model="emailToFromName" placeholder="Tu Nombre" :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Comentarios Adicionales" description="Máximo 200 caracteres">
                            <b-form-textarea v-model="emailToComments" placeholder="Ej. '¡Feliz Cumpleaños!'" maxlength="200"></b-form-textarea>
                        </b-form-group>
                    </div>
                    
                    <div v-if="!Object.keys(userCardDetails).length">
                        <hr />
                        <payment-method cols-lg="12" :user-resource="userResource" @success="onCardAdded">
                            <b-alert variant="success" show><b-icon icon="lock-fill" /> Tu tarjeta aún no será cargada</b-alert>
                        </payment-method>
                    </div>
                    
                    <div v-else>
                        <b-alert variant="info" show>Tu <strong>{{ userCardDetails.brand }} terminada en {{ userCardDetails.last4 }}</strong> será cargada {{ currencySymbol() }}{{ moneyFormat(amountCents) }}.</b-alert>
                        <small class="text-muted"><terms-of-service-link /></small>
                        <messages class="mt-3" />
                        <b-button type="submit" class="col-sm-12 mt-3" :disabled="loading">Comprar Vale de Regalo</b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>

        <div v-else-if="showSuccess">
            <b-alert variant="success" show><strong>¡Éxito! ¡Tu vale de regalo ha sido comprado!</strong> <span v-if="emailTo">Este vale de regalo también ha sido enviado a <strong>{{ emailToEmail }}</strong></span></b-alert>
            <p>Por favor, anota el código a continuación. Ingresar este código durante el pago aplicará el saldo de este vale a tu costo de pago.</p>
            <b-card header="Código de Vale">
                <h4 class="text-center mb-0">
                    {{ voucherResource }}
                </h4>
            </b-card>
            <b-button variant="primary" class="col-sm-12 mt-3" @click="onSuccess">Todo Listo</b-button>
        </div>

        <div v-else>
            <b-skeleton-wrapper>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-skeleton-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
</style>
